/**
 * Separator — a hairline divider on Flint's `line` token.
 *
 * Lightweight div-based implementation (no extra Radix dep). Used by the
 * `Sidebar` primitive's `SidebarSeparator` and available for general use.
 */
import * as React from "react";
import { cn } from "../lib/cn.js";

export interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: "horizontal" | "vertical";
}

export const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(function Separator(
  { className, orientation = "horizontal", ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      role="separator"
      aria-orientation={orientation}
      className={cn(
        "shrink-0 bg-line",
        orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
        className,
      )}
      {...props}
    />
  );
});
